export default function isElementOverflowing(element: HTMLElement): boolean {
  // For some reason scrollHeight is always 1-2px larger than the clientHeight
  // it seems
  return element.scrollHeight > element.clientHeight + 2;
}
